import React, { Component } from 'react';
import { Tabs, Tab, ButtonToolbar, Button, Col } from 'react-bootstrap';
import { PropTypes } from 'prop-types';

import { EditionsCommand } from '../../commands/EditionsCommand';
import { SearchBar } from '../../../SearchBar';
import { TitleRow } from '../../../TitleRow';
import { HandleMessage } from '../../../HandleMessage';
import { EditionsList } from '../EditionsList';
import { EditionNameForm } from '../forms/EditionNameForm';

export class TransportAuthorityEditions extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
        edition: PropTypes.object
    }

    constructor(props) {
        super(props);

        this.state = {
            selectedTab: "county",
            filter: "",
            form: {
                operation: "create",
                showNameForm: false,
                inputError: null,
                id: 0,
                name: "",
                successMessage: ""
            },
            callbacks: {
                list: {
                    county: undefined,
                },
                refresh: {
                    county: undefined,
                }
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        };
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);
    }

    // ---------------------------

    isTransportAuthorityData() {
        const { selectedProvider } = this.context;

        return undefined !== selectedProvider && selectedProvider.startsWith("0:");
    }

    // ---------------------------

    listCallback(type, func) {
        const { callbacks } = this.state;

        callbacks.list[type] = func;

        this.setState({
            callbacks: callbacks
        });
    }

    refreshCallback(type, func) {
        const { callbacks } = this.state;

        callbacks.refresh[type] = func;

        this.setState({
            callbacks: callbacks
        });
    }

    operationSuccessCallback(type, message) {
        const { edition } = this.context;
        const { callbacks } = this.state;

        if ("function" === typeof callbacks.refresh[type]) {
            callbacks.refresh[type]();
        }

        // Update Transport Authority selected Editions
        if (null !== edition && undefined !== edition) {
            edition.update(edition.date, undefined, true);
        }
        this.onHideForm();

        this.setState({
            message: {
                show: true,
                message: message,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });
    }

    operationErrorCallback(message) {
        this.onHideForm();

        this.setState({
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // ---------------------------

    onSearch(filter) {
        this.setState({
            filter: filter
        });
    }

    onSelectTab(key) {
        this.setState({
            selectedTab: key
        });
    }

    onCreateClick() {
        const { form } = this.state;

        form.id = 0;
        form.name = "";
        form.inputError = null;
        form.showNameForm = true;
        form.successMessage = "Edição criada com sucesso.";

        this.setState({
            form: form
        });
    }

    onChangeNameForm(input) {
        const { form } = this.state;

        form.name = input.target.value;
        if (null === form.name || undefined === form.name || "" === form.name) {
            form.inputError = "error";
        }
        else {
            form.inputError = null;
        }

        this.setState({
            form: form
        });
    }

    onSaveNameForm() {
        const { selectedTab, form } = this.state;

        new EditionsCommand()
            .save(
                selectedTab,
                form,
                () => this.operationSuccessCallback(selectedTab, form.successMessage),
                (a) => this.operationErrorCallback(a)
            );
    }

    onHideForm() {
        const { form } = this.state;

        form.showNameForm = false;

        this.setState({
            form: form
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    // ---------------------------

    renderNameForm() {
        const { form } = this.state;

        if (form.showNameForm) {
            return (
                <EditionNameForm title="Introduza o nome da Edição"
                    value={form.name}
                    inputError={form.inputError}
                    onChangeValue={(a) => this.onChangeNameForm(a)}
                    onSave={() => this.onSaveNameForm()}
                    onHide={() => this.onHideForm()} />
            );
        }

        return null;
    }

    render() {
        const { selectedTab, filter, message } = this.state;

        return (
            <div>
                <TitleRow title="Edições" showSeparator={true}>
                    <Col className="padding-0" xs={2} sm={1} md={4}>
                        <ButtonToolbar className="pull-right title-row-col-btns">
                            <Button onClick={() => this.onCreateClick()}>CRIAR</Button>
                        </ButtonToolbar>
                    </Col>
                    <Col className="padding-0" xs={10} sm={11} md={8}>
                        <div className="search-bar">
                            <SearchBar onSearch={(a) => this.onSearch(a)} />
                        </div>
                    </Col>
                </TitleRow>

                <div className="margin-top-15">
                    <Tabs id="datamanager_tabs" activeKey={selectedTab} onSelect={(a) => this.onSelectTab(a)}>
                        <Tab eventKey="county" title="Município">
                            <EditionsList type="county"
                                filter={filter}
                                refreshCallback={(a) => this.refreshCallback("county", a)}
                                listCallback={(a) => this.listCallback("county", a)} />
                        </Tab>
                    </Tabs>
                </div>

                {this.renderNameForm()}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/editions/transportAuthorityEditions/TransportAuthorityEditions.js